module.exports = __webpack_public_path__ + "static/media/Encil_04.1e06c19e.pdf";